export default class Mails {
  constructor(args) {
    console.log('mails_received.js loaded');

    // let mailList = document.getElementById("js_mailList");
    // mailList.onclick = function (elem) {
    //   location.href = "/mails/"+elem.data("id");
    // }
    //
    // $('.mailList').find('tbody').find('tr').click(function() {
    //   location.href = "/mails/"+$(this).data("id");
    // });
  }

  // methods
}



// WEBPACK FOOTER //
// ./pages/mails_received.js